var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "package_list_config",
      attrs: {
        "hide-required-asterisk": "",
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { staticClass: "margin_top", attrs: { prop: "margin_top" } },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "z_index", attrs: { prop: "z_index" } },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "upload-item" }, [
        _c("div", { staticClass: "item-title" }, [_vm._v("顶部方案图")]),
        _c(
          "div",
          { staticClass: "upload" },
          [
            _c("el-form-item", { attrs: { prop: "head_image" } }, [
              _c(
                "div",
                { staticClass: "upload-item-wrap" },
                [
                  _c("upload-file", {
                    ref: "uploadBannerHeader",
                    attrs: {
                      "link-url": _vm.linkUrl,
                      tempurl: _vm.value.config.head_image,
                      canDel: Boolean(_vm.value.config.head_image),
                      deletePadding: true,
                      uploadInfo: _vm.uploadInfo,
                    },
                    on: {
                      onDelete: function ($event) {
                        return _vm.onDelete(_vm.value.config, "head_image")
                      },
                      emitUploadFile: function (res) {
                        return _vm.emitUploadFile(
                          res,
                          _vm.value.config,
                          "head_image"
                        )
                      },
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "btns" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onUpload("Header")
                            },
                          },
                        },
                        [_vm._v("上传图片")]
                      ),
                      _vm.pictureInfo[1]
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectPicture(1)
                                },
                              },
                            },
                            [_vm._v(" 选择图片 ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            !_vm.isPackageListDecoration
              ? _c(
                  "el-form-item",
                  { attrs: { prop: "programme_unique_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "选择方案",
                        },
                        on: { change: _vm.changeProject },
                        model: {
                          value: _vm.value.config.programme_unique_id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value.config,
                              "programme_unique_id",
                              $$v
                            )
                          },
                          expression: "value.config.programme_unique_id",
                        },
                      },
                      _vm._l(_vm.customerProjectList, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.unique_id,
                            attrs: {
                              label: item.new_name,
                              value: item.unique_id,
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(item.new_name))]),
                            item.plan_mode + "" === "1"
                              ? _c(
                                  "span",
                                  { staticClass: "option-promo-tag" },
                                  [_vm._v("促销")]
                                )
                              : _vm._e(),
                            item.promotion_type + "" === "1"
                              ? _c(
                                  "span",
                                  { staticClass: "option-special-tag" },
                                  [_vm._v("专用")]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "el-form-item",
        { attrs: { prop: "background_colour", label: "礼包背景颜色" } },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.background_colour,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "background_colour", $$v)
              },
              expression: "value.config.background_colour",
            },
          }),
        ],
        1
      ),
      _vm._l(_vm.value.config.value, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "upload-item" },
          [
            _c("div", { staticClass: "item-title" }, [
              _c("span", [_vm._v(" 礼包" + _vm._s(index + 1) + " ")]),
              _vm.value.config.value.length > 1
                ? _c("i", {
                    staticClass: "el-icon el-icon-delete",
                    on: {
                      click: function ($event) {
                        return _vm.handleDelUpload(index)
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "upload" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "value." + index + ".package_image",
                      rules: [{ required: true, message: "图片不可为空" }],
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "upload-item-wrap" },
                      [
                        _c("upload-file", {
                          ref: "uploadBanner",
                          refInFor: true,
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: item.package_image,
                            uploadInfo: _vm.uploadInfo,
                          },
                          on: {
                            emitUploadFile: function (res) {
                              return _vm.emitUploadFile(
                                res,
                                item,
                                "package_image"
                              )
                            },
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "btns" },
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onUpload(index)
                                  },
                                },
                              },
                              [_vm._v(" 上传图片 ")]
                            ),
                            _vm.pictureInfo[2]
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectPicture(2, index)
                                      },
                                    },
                                  },
                                  [_vm._v(" 选择图片 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "value." + index + ".package_unique_id",
                  rules: [{ required: true, message: "礼包不可为空" }],
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: "选择礼包",
                    },
                    on: {
                      change: function (val) {
                        return _vm.changePackage(val, index)
                      },
                    },
                    model: {
                      value: item.package_unique_id,
                      callback: function ($$v) {
                        _vm.$set(item, "package_unique_id", $$v)
                      },
                      expression: "item.package_unique_id",
                    },
                  },
                  _vm._l(_vm.customerPackageList, function (packageItem) {
                    return _c(
                      "el-option",
                      {
                        key: packageItem.unique_id,
                        attrs: {
                          label: packageItem.new_name,
                          value: packageItem.unique_id,
                        },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(packageItem.new_name))]),
                        packageItem.plan_mode + "" === "1"
                          ? _c("span", { staticClass: "option-promo-tag" }, [
                              _vm._v("促销"),
                            ])
                          : _vm._e(),
                        packageItem.promotion_type + "" === "1"
                          ? _c("span", { staticClass: "option-special-tag" }, [
                              _vm._v("专用"),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "value." + index + ".package_name",
                  rules: [{ required: true, message: "礼包名称不可为空" }],
                },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "", placeholder: "礼包名称" },
                  model: {
                    value: item.package_name,
                    callback: function ($$v) {
                      _vm.$set(item, "package_name", $$v)
                    },
                    expression: "item.package_name",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus add-upload",
          attrs: { type: "primary" },
          on: { click: _vm.addPackage },
        },
        [_vm._v(" 添加礼包")]
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureIndex: _vm.pictureIndex,
              depot: _vm.depot,
              pictureList: _vm.pictureList,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }